module.exports = __webpack_public_path__ + "files/ec610d17cf5f36692ec30acd34c155c1.png";